import React from 'react';

export const RequestTrafficPinImage = () => {
    return (
        <svg
            width="372"
            height="140"
            viewBox="0 0 372 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M218.323 70.1184L286.101 109.918L254.359 128.242L186.581 88.4428L218.323 70.1184Z"
                fill="url(#paint0_linear_4436_112289)"
            />
            <path
                d="M281.216 34.2317L124.81 124.525L93.0685 106.2L249.474 15.9073L281.216 34.2317Z"
                fill="url(#paint1_linear_4436_112289)"
            />
            <path
                d="M185.761 51.7668C186.717 51.2147 188.268 51.2146 189.225 51.7668L219.486 69.2364C220.441 69.7886 220.442 70.6841 219.486 71.2363L189.069 88.7957C188.113 89.3478 186.562 89.3476 185.605 88.7957L155.344 71.3261C154.388 70.7739 154.388 69.8785 155.344 69.3262L185.761 51.7668ZM187.337 87.7957L217.753 70.2363L187.493 52.7668L157.076 70.3262L187.337 87.7957Z"
                fill="#BED2FF"
            />
            <path
                d="M250.511 33.8535L124.537 106.578"
                stroke="white"
                strokeWidth="2"
                strokeDasharray="10 10"
            />
            <path
                d="M191.687 72.4681L249.519 106.579"
                stroke="white"
                strokeWidth="2"
                strokeDasharray="10 10"
            />
            <path
                d="M177.227 32.6182C184.778 32.6182 190.954 38.8633 190.954 46.5273C190.954 49.0247 190.1 51.719 188.783 54.3779C187.469 57.0322 185.711 59.6184 183.945 61.8926C182.18 64.1653 180.414 66.1168 179.089 67.5C178.426 68.1913 177.875 68.7399 177.489 69.1152C177.392 69.2102 177.304 69.293 177.229 69.3652C177.153 69.2919 177.064 69.2079 176.966 69.1113C176.58 68.7324 176.029 68.1782 175.366 67.4814C174.041 66.0871 172.274 64.1225 170.509 61.8408C168.742 59.5576 166.985 56.9664 165.671 54.3184C164.354 51.6651 163.5 48.9887 163.5 46.5273C163.5 38.8634 169.675 32.6184 177.227 32.6182Z"
                fill="#676DFD"
                stroke="#333333"
            />
            <path
                d="M177.228 52.2038C180.463 52.2038 183.086 49.5809 183.086 46.3455C183.086 43.1101 180.463 40.4873 177.228 40.4873C173.992 40.4873 171.37 43.1101 171.37 46.3455C171.37 49.5809 173.992 52.2038 177.228 52.2038Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_4436_112289"
                    x1="257.972"
                    y1="123.193"
                    x2="203.541"
                    y2="80.4665"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#EFEFFC" />
                    <stop offset="0.382353" stopColor="#DEE6FD" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_4436_112289"
                    x1="89.4863"
                    y1="131.151"
                    x2="182.644"
                    y2="-41.2656"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.134496" stopColor="#EFEFFC" />
                    <stop offset="0.268485" stopColor="#DEE6FD" />
                    <stop offset="0.769449" stopColor="#DEE6FD" />
                    <stop offset="0.863921" stopColor="#EFEFFC" />
                </linearGradient>
            </defs>
        </svg>
    );
};
